export default "<div>\r\n    <app-barra-navegacion></app-barra-navegacion>\r\n    <app-loader></app-loader>\r\n    <router-outlet></router-outlet>\r\n</div>"